import { render, staticRenderFns } from "./skeletonPaper.vue?vue&type=template&id=2f5251d4&scoped=true&"
var script = {}
import style0 from "./skeletonPaper.vue?vue&type=style&index=0&id=2f5251d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5251d4",
  null
  
)

export default component.exports